var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "c-search-box",
        { ref: "searchbox", on: { enter: _vm.getList } },
        [
          _c("template", { slot: "search" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3" },
              [
                _c("c-select", {
                  attrs: {
                    codeGroupCd: "MATERIAL_KIND_CD",
                    type: "search",
                    itemText: "codeName",
                    itemValue: "code",
                    name: "materialKindCd",
                    label: "자재구분",
                  },
                  on: { input: _vm.getList },
                  model: {
                    value: _vm.searchParam.materialKindCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "materialKindCd", $$v)
                    },
                    expression: "searchParam.materialKindCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3" },
              [
                _c("c-material-type", {
                  attrs: {
                    type: "search",
                    label: "자재분류",
                    name: "materialTypeCd",
                  },
                  on: { input: _vm.getList },
                  model: {
                    value: _vm.searchParam.materialTypeCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "materialTypeCd", $$v)
                    },
                    expression: "searchParam.materialTypeCd",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        2
      ),
      _c(
        "c-table",
        {
          ref: "materialTable",
          attrs: {
            title: "자재 목록",
            columns: _vm.grid.columns,
            data: _vm.grid.data,
            gridHeight: _vm.grid.height,
            selection: _vm.popupParam.type,
            columnSetting: false,
            isExcelDown: false,
            isFullScreen: false,
            rowKey: "materialCd",
          },
          on: { rowDblclick: _vm.rowDblclick },
        },
        [
          _c(
            "template",
            { slot: "table-button" },
            [
              _c(
                "q-btn-group",
                { attrs: { outline: "" } },
                [
                  _c("c-btn", {
                    attrs: { label: "LBLSELECT", icon: "check" },
                    on: { btnClicked: _vm.select },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }